import React, { useState } from "react";

const DISCORD_WEBHOOK_URL =
  "https://discord.com/api/webhooks/1375117241728761856/8Q0BJKkfjpyz8Ubgf5T9uy-7DbXwrJKHTp1KmFGLVv4FcDueexc7AFDsIs_p3Z0G7Ryi";

const BuilderApplication = () => {
  const [formData, setFormData] = useState({
    name: "",
    discord: "",
    portfolioLink: "",
    experience: "",
    whyJoin: "",
  });

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const embed = {
      title: "🧱 New Builder Application",
      color: 0x00b0f4,
      fields: [
        {
          name: "Full Name",
          value: formData.name || "N/A",
        },
        {
          name: "Discord Tag",
          value: formData.discord || "N/A",
        },
        {
          name: "Portfolio Link",
          value: formData.portfolioLink || "N/A",
        },
        {
          name: "Experience",
          value: formData.experience || "N/A",
        },
        {
          name: "Why Join",
          value: formData.whyJoin || "N/A",
        },
      ],
      timestamp: new Date().toISOString(),
    };

    try {
      const res = await fetch(DISCORD_WEBHOOK_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ embeds: [embed] }),
      });

      if (res.ok) {
        setSuccessMsg("✅ Application submitted successfully!");
        setErrorMsg("");
        setFormData({
          name: "",
          discord: "",
          portfolioLink: "",
          experience: "",
          whyJoin: "",
        });
      } else {
        setErrorMsg("❌ Submission failed. Please try again.");
        setSuccessMsg("");
      }
    } catch (err) {
      setErrorMsg("❌ Network error. Please try again later.");
      setSuccessMsg("");
    }
  };

  return (
    <div className="container" style={{ maxWidth: 500, margin: "2rem auto" }}>
      <h2>Builder Application</h2>
      <p>Apply to join the RixxyMC build team.</p>

      <form onSubmit={handleSubmit}>
        <label htmlFor="name">Full Name:</label>
        <input
          type="text"
          id="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Your full name"
          required
        />

        <label htmlFor="discord">Discord Tag (e.g. user#1234):</label>
        <input
          type="text"
          id="discord"
          value={formData.discord}
          onChange={handleChange}
          placeholder="Your Discord tag"
          required
        />

        <label htmlFor="portfolioLink">Portfolio or Previous Builds Link:</label>
        <input
          type="url"
          id="portfolioLink"
          value={formData.portfolioLink}
          onChange={handleChange}
          placeholder="Link to your work (optional)"
        />

        <label htmlFor="experience">Describe your building experience:</label>
        <textarea
          id="experience"
          rows="4"
          value={formData.experience}
          onChange={handleChange}
          placeholder="Tell us about your building skills"
          required
        ></textarea>

        <label htmlFor="whyJoin">Why do you want to join the build team?</label>
        <textarea
          id="whyJoin"
          rows="4"
          value={formData.whyJoin}
          onChange={handleChange}
          placeholder="Why should we choose you?"
          required
        ></textarea>

        <button type="submit" style={{ marginTop: "1rem" }}>
          Submit Application
        </button>

        {successMsg && (
          <div style={{ marginTop: "1rem", color: "green" }}>{successMsg}</div>
        )}
        {errorMsg && (
          <div style={{ marginTop: "1rem", color: "red" }}>{errorMsg}</div>
        )}
      </form>
    </div>
  );
};

export default BuilderApplication;
